import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      opacity={0.6}
      stroke="#000"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 5.999V1.332h8v4.667M4 12H2.667a1.334 1.334 0 0 1-1.333-1.333V7.333A1.333 1.333 0 0 1 2.667 6h10.666a1.333 1.333 0 0 1 1.334 1.333v3.334A1.333 1.333 0 0 1 13.334 12H12" />
      <path d="M12 9.332H4v5.333h8V9.332Z" />
    </g>
  </svg>
);

export default SvgComponent;
